<template>
    <div style="text-align: center;">
        管理系统
    </div>
</template>

<script>
    export default {
        name: "Home",
    };
</script>

<style>

</style>